import React, { Component } from "react";
import Message from "./Messages";
import { getDispatcherName } from "./utils";

class MessageList extends Component {
  componentDidMount () {
    if (this.props.driverInfo.unReadCount > 0) {
      this.scrollIntoView?.scrollIntoView({behavior: 'smooth'});
    } else {
      this.scrollList.scrollTop = this.scrollList.scrollHeight;
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.messages.length !== prevProps.messages.length &&
      this.props.driverInfo.unReadCount === 0 //if message container is opened and driver sent new message the stay in same  if there is unread messages else scroll to bottom
    ) {
      this.scrollList.scrollTop = this.scrollList.scrollHeight;
    }
  }
  scrollFunction = (el) => {
    this.scrollList = el;
  };

  scrollIntoViewFunction = (el) => {
    this.scrollIntoView = el;
  }
  render() {
    const { classes, driverInfo } = this.props;
    return (
      <div
        className={`${classes.selectedMessages} ${classes.scMessageList} customScroll`}
        ref={this.scrollFunction}
      >
        {this.props.messages.length > 0 &&
          this.props.messages.map((message, i) => {
            return (
              <Message
                classes={classes}
                message={message}
                messageNumber={this.props.messages.length - i - 1}
                key={`${i}messagesList`}
                unReadCount={driverInfo.unReadCount}
                onReplyMsgSelected={this.props.onReplyMsgSelected}
                unReadMessageRef={this.scrollIntoViewFunction}
                terminalOffset={this.props.terminalOffset}
                dispatcherName={getDispatcherName(message)}
              />
            );
          })}
      </div>
    );
  }
}

export default MessageList;
